export default "__VITE_ASSET__1508ba18__"